import React from 'react';
import TextField from "@mui/material/TextField";
import {getHelperText} from "../../yupLocalization";

const SimpleTextfield = ({t, register, errors, fieldName, labelKey, additionalHelper, helperTextNamespace, labelNamespace, fullWidth=true, ...rest}) => {
    return (
        <TextField
            {...rest}
            {...register(fieldName)}
            fullWidth={fullWidth}
            error={errors && !!errors[fieldName]}
            helperText={getHelperText(t, errors, fieldName, helperTextNamespace) || additionalHelper}
            variant="standard"
            label={labelNamespace ? t(labelKey, {ns: labelNamespace}) : t(labelKey)}/>
    )
}

export default SimpleTextfield;